import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supplierClient } from '../lib/supplierClient';

/**
 * Wraps supplier-only routes. Requires a signed-in user whose auth.uid()
 * has a row in supplier_users.
 */
const SupplierRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [state, setState] = useState('checking');

  useEffect(() => {
    let cancelled = false;
    if (loading) return;
    if (!user) { setState('no'); return; }
    supplierClient.isSupplier()
      .then((ok) => { if (!cancelled) setState(ok ? 'yes' : 'no'); })
      .catch(() => { if (!cancelled) setState('no'); });
    return () => { cancelled = true; };
  }, [user, loading]);

  if (loading || state === 'checking') {
    return (
      <div data-testid="supplier-route-loading" className="flex min-h-[60vh] items-center justify-center">
        <div className="label-overline text-neutral-500">Loading supplier portal…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (state === 'no') {
    return <Navigate to="/supplier/claim" replace />;
  }
  return children;
};

export default SupplierRoute;
